import { getFunctions, httpsCallable } from 'firebase/functions';

const COOKIE_NAME = '__fl_sso';
const COOKIE_DOMAIN = '.joseph-lee.app';

export function setSSOCookie(token) {
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(token)}; domain=${COOKIE_DOMAIN}; max-age=3600; path=/; SameSite=Lax`;
}

export function getSSOCookie() {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function clearSSOCookie() {
  document.cookie = `${COOKIE_NAME}=; domain=${COOKIE_DOMAIN}; max-age=0; path=/`;
}

export function createGetCustomToken(app) {
  const functions = getFunctions(app);
  return httpsCallable(functions, 'getCustomToken');
}
